module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-left-white-3dbc09cb.svg";